export const findScrollableParents = (element: Element): Element[] => {
  const parents: Element[] = [];
  let current = element.parentElement;

  while (current && current !== document.body) {
    if (isScrollable(current)) {
      parents.push(current);
    }
    current = current.parentElement;
  }

  return parents;
};

const isScrollable = (element: Element): boolean => {
  const style = window.getComputedStyle(element);
  const overflow = style.overflow + style.overflowX + style.overflowY;
  return overflow.includes("scroll") || overflow.includes("auto");
};
